import { createApi } from "@reduxjs/toolkit/query/react";
import { QueryArg, axiosBaseQuery } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { handleTokenUpdate } from "./helpers";
import { AzureLoginArgs, LoginArgs, RefreshArgs } from "./types";

export type SSOArgs = {
  hostname: string;
};

export type SSOProvider = {
  name: string;
  url: string;
};

const getSSOProviders = (args: SSOArgs): QueryArg => ({
  url: '/sso/providers',
  method: RequestMethod.GET,
  params: args,
});


const login = (args: LoginArgs): QueryArg => ({
  url: "/login",
  method: RequestMethod.POST,
  data: args,
});

const refreshToken = (args: RefreshArgs): QueryArg => ({
  url: "/refreshToken",
  method: RequestMethod.POST,
  data: args,
});

const azureLogin = (args: AzureLoginArgs): QueryArg => ({
  url: "/azure/login",
  method: RequestMethod.POST,
  params: args,
});

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/auth" }),
  endpoints: (build) => ({    
    getSSOProviders: build.query<SSOProvider[], SSOArgs>({
      query: getSSOProviders,
    }),

    login: build.mutation<{ accessToken: string; refreshToken: string }, LoginArgs>({
      query: login,
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        await handleTokenUpdate(queryFulfilled, dispatch);
      },
    }),

    refreshToken: build.mutation<{ accessToken: string }, RefreshArgs>({
      query: refreshToken,
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        await handleTokenUpdate(queryFulfilled, dispatch);
      },
    }),

    azureLogin: build.mutation<{ accessToken: string; refreshToken: string }, AzureLoginArgs>({
      query: azureLogin,
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        await handleTokenUpdate(queryFulfilled, dispatch, true);
      },
    }),
  }),
});
